import { numberType } from "types";

import { get, IHttpRequestConfig, post, remove } from "@/browser";
import { applyHeaders, extractDataFromResponse } from "@/core/api";
import { compose } from "@/core/url";

import { arrayKeywordType, IKeyword } from "./types";

const API = {
  searchHistory: "/api/search-history/job-requests",
  addSearchHistory: "/api/search-history/job-requests",
  deleteSearchHistory: "/api/search-history/job-requests/{keywordId}",
};

export interface IFetchKeywordsSearchHistory {
  companyId?: number;
  query?: string;
  onQueryChange?: (query: string) => void;
}

export const fetchKeywordsSearchHistory = async (params: IFetchKeywordsSearchHistory, options?: IHttpRequestConfig) => {
  const { companyId, ...searchParams } = params;
  const url = compose(API.searchHistory, {}, searchParams);
  return get<IKeyword[]>(url, applyHeaders({ companyId }, options))
    .then(extractDataFromResponse)
    .then(arrayKeywordType);
};

export interface IDeleteKeywordsSearchHistory {
  keywordId: number;
  companyId?: number;
}

export const deleteKeywordSearchHistory = async (
  params: IDeleteKeywordsSearchHistory,
  options?: IHttpRequestConfig,
) => {
  const { companyId, keywordId } = params;
  const url = compose(API.deleteSearchHistory, { keywordId });
  return remove<number>(url, {}, applyHeaders({ companyId }, options)).then(extractDataFromResponse).then(numberType);
};

export interface IAddKeywordsSearchHistory {
  companyId?: number;
}

export const addKeywordSearchHistory = async (
  params: IAddKeywordsSearchHistory,
  data: Pick<IKeyword, "keyword">,
  options?: IHttpRequestConfig,
) => {
  const { companyId } = params;
  const url = compose(API.addSearchHistory);
  return post<number>(url, data, applyHeaders({ companyId }, options)).then(extractDataFromResponse).then(numberType);
};
